import {
  ComponentPropsWithoutRef,
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
} from 'react';
import { calendar as formCalendar } from '../../form/field/calendar-input';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;
type FormCalendarProps = ComponentPropsWithoutRef<typeof formCalendar>;

type Props = FormCalendarProps;

export const calendar: FR<HTMLDivElement, Props> = forwardRef((props, ref) => {
  const FormCalendar = formCalendar;

  return <FormCalendar {...props} ref={ref} />;
});

calendar.displayName = 'SiloReal-Filter-Field-Calendar';

export type { CalendarInputValue } from '../../form/field/calendar-input';
